const CONFIG = {
    // Локальная разработка:
    // HOST: 'http://codereadai/api',
    
    // Production (на сервере):
     HOST: 'https://codereadai.ru/api',  // HTTPS для SSL
};

export default CONFIG;